import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './ButtonRedLarge.module.css';

export default class ButtonRedLarge extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        glyph: PropTypes.oneOf(['speakers']),
        glitch: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
    }

    render() {
        const classNameBase = classNames(styles.base, {
            [styles[`base__${this.props.glyph}`]]: this.props.glyph,
            [styles.glitch]: this.props.glitch,
        })

        return (
            <button className={classNameBase} onClick={this.props.onClick}>
                <span className={styles.content}>{this.props.children}</span>
            </button>
        )
    }
}
